module.exports = __webpack_public_path__ + "static/media/cross-circle.53b0ff6d.svg";